import axios from "../libs/axios";
import qs from "qs";
import authHeader from "./auth-header";

const END_POINT = `${process.env.VUE_APP_API_ENDPOINT}`;

class FormService {
  get(id) {
    return axios.get(`${END_POINT}/v1/form/${id}`);
  }

  find(query) {
    return axios.post(`${END_POINT}/v1/forms`, { query });
  }
  findOne(query) {
    const paramsSerializer = query => qs.stringify(query);
    return axios.get(`${END_POINT}/v1/form`, { query, paramsSerializer });
  }

  answer(category, sei, mei, mansionName, mansion, roomNo, result, isPublic) {
    return axios.post(`${END_POINT}/v1/answer/public`, {
      category,
      sei,
      mei,
      mansionName,
      mansion,
      roomNo,
      result,
      isPublic,
    });
  }
  private(category, sei, mei, mansionName, mansion, roomNo, result, isPublic) {
    return axios.post(
      `${END_POINT}/v1/answer/private`,
      {
        category,
        sei,
        mei,
        mansionName,
        mansion,
        roomNo,
        result,
        isPublic,
      },
      {
        headers: authHeader(),
      },
    );
  }

  getContactCategories() {
    return axios.get(`${END_POINT}/v1/contact-categories`);
  }
}

export default new FormService();
